export default "__VITE_ASSET__8de3aabd__"